import { Form, Input, message, Typography, Button } from "antd";
import { LanguageChange } from "shared/components";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router";
import {
  fetchUserDeviceCheck,
  validateUserDeviceCode,
} from "shared/service/StrmService";
import { getLoggedUser } from "explorer/reducers/users";
import { useDispatch } from "react-redux";
import { getBrowserId } from "shared/helpers/browser-id";
import { getGeneros, getGenerosSpotify } from "explorer/reducers/generos";
import { ReactComponent as Logo } from "shared/assets/images/logo-strm.svg";
import { getCountries } from "explorer/reducers/countries";
import { loginReduced } from "explorer/reducers/auth";
import { useState } from "react";
import { isMobile } from "react-device-detect";
import { getMonitoredData } from "explorer/reducers/monitored-data";
import { getUserDistroToken } from "explorer/reducers/artistas";

const VerificacaoDispositivo: React.FC<RouteComponentProps> = (props) => {
  const { history } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const onFinish = async () => {
    const values = await form.validateFields();
    setLoading(true);
    const response = await validateUserDeviceCode(
      values.codigo,
      getBrowserId()
    );
    setLoading(false);
    if (response) {
      dispatch(getLoggedUser());
      dispatch(getGenerosSpotify());
      dispatch(getGeneros());
      dispatch(getCountries());
      dispatch(loginReduced());
      dispatch(getMonitoredData());
      dispatch(getUserDistroToken());
      message.success(t("pages.VerificacaoLogin.sucesso"));
      const returnURL = sessionStorage.getItem("returnURL");
      sessionStorage.removeItem("returnURL");
      if (returnURL) history.push(returnURL);
      else history.push("/");
    } else {
      message.error(t("pages.VerificacaoLogin.error"));
    }
  };

  const onClickReenvia = async () => {
    await fetchUserDeviceCheck(getBrowserId());
    message.info(t("pages.VerificacaoLogin.mensagemReenvio"), 10);
  };

  return (
    <div
      className="conteudo-centralizado login"
      style={{
        height: "100vh",
        backgroundColor: "#1a191a",
        padding: "14px 26px",
      }}
    >
      <div className="direction">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div className="logo-region">
            <Logo className="logo" style={{ width: isMobile ? 80 : 100 }} />
            <span style={{ fontSize: isMobile ? 14 : 28 }}>for labels</span>
          </div>
          <LanguageChange.SelectLanguageChange />
        </div>
        <Form form={form} onFinish={onFinish}>
          <div className="content" style={{ marginTop: 154 }}>
            <div className="text">
              <Typography.Title style={{ color: "#FFFFFF" }}>
                {t("pages.VerificacaoLogin.titulo")}
              </Typography.Title>
              <Typography.Text style={{ color: "#FFFFFF" }}>
                {t("pages.VerificacaoLogin.verificacaoMensagem")}
              </Typography.Text>
            </div>
            <div className="input">
              <Form.Item
                name="codigo"
                rules={[
                  {
                    required: true,
                    message: t("pages.VerificacaoLogin.codigoObrigatorio"),
                  },
                ]}
                normalize={(value) => value?.trim()}
              >
                <Input placeholder={t("pages.VerificacaoLogin.codigo")} />
              </Form.Item>
            </div>
            <div className="enter-button">
              <button
                className="botao-roxo"
                style={{ marginBottom: "16px" }}
                disabled={loading}
              >
                {t("pages.VerificacaoLogin.submit")}
              </button>
            </div>
            <div className="esqueci-senha">
              <Button
                type="link"
                htmlType="button"
                onClick={onClickReenvia}
                className="button-reset-senha"
                style={{ margin: 0 }}
                disabled={loading}
              >
                {t("pages.VerificacaoLogin.reenvioCodigo")}
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default VerificacaoDispositivo;
